export enum Locale {
    Pl = 'pl',
    En = 'enGB',
}
